import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import btsmsConfig from '../../btsms/btsmsConfig.vue';
import govuknotifysmsConfig from '../../govuknotifysms/govuknotifysmsConfig.vue';
import messengerConfig from '../../messenger/messengerConfig.vue';
import whatsappConfig from '../../messenger/whatsappConfig.vue';
import Toast from '@/shared/services/toast';
import { GET_CHANNEL_IDENTITIES } from '@/store/channel-identities/actionTypes';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppConfig',
  setup(__props) {

const configComponents = {
  btsmsConfig,
  govuknotifysmsConfig,
  messengerConfig,
  whatsappConfig,
};

const router = useRouter();
const store = useStore();
const currentApp = computed(() => store.getters.currentApp);
const loadChannelIdentities = (forceReload = false): Promise<ChannelIdentityViewModel[]> =>
  store.dispatch(GET_CHANNEL_IDENTITIES, forceReload);

const isLoading = ref(true);

function getComponentName() {
  if (currentApp.value.id === 'instagram') {
    return configComponents.messengerConfig;
  }

  const componentKey = `${currentApp.value.id.replaceAll('-', '')}Config` as keyof typeof configComponents;
  return configComponents[componentKey];
}

async function configSaved(stopRedirect: boolean) {
  await loadChannelIdentities(true);
  if (!stopRedirect) {
    // go back to appstore
    await router.push({ name: 'apps' });
  }
  Toast.showSuccess('App setup completed');
}

function loaded() {
  isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(getComponentName()), {
      onConfigSaved: configSaved,
      onLoaded: _cache[0] || (_cache[0] = ($event: any) => (loaded()))
    }, null, 544)), [
      [_vShow, !isLoading.value]
    ])
  ]))
}
}

})